import {
    MAP_SALESCHANNEL_TO_VIRTUAL_ID,
    SalesChannel,
    ADDITIONAL_PAGE_OPTIONS,
} from '@vfde-sails/constants';

/**
 * getDefaultSubscriptionIds for device first use case
 * consumer and young -> we send all tariffs except XL
 */
export const getDefaultSubscriptionIds = (salesChannel: SalesChannel): string[] => {
    const { excludedTariffIds } = window[ADDITIONAL_PAGE_OPTIONS];

    return MAP_SALESCHANNEL_TO_VIRTUAL_ID[salesChannel].filter(tariffId =>
        !excludedTariffIds?.[salesChannel]
        || !excludedTariffIds[salesChannel]!.some(excludedTariffId => tariffId === excludedTariffId),
    );
};
